import { render, staticRenderFns } from "./ProjectActions.vue?vue&type=template&id=aa5bf276&"
import script from "./ProjectActions.vue?vue&type=script&lang=js&"
export * from "./ProjectActions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports